import { ConversationEngineState } from "./types";

export type EngineEvent =
  | { type: "UserMessageSent" }
  | { type: "AssistantStreamStarted" }
  | { type: "AssistantDisplayCompleted"; hasStreamingRequests: boolean }
  | { type: "AssistantTextCompleted" }
  | { type: "ToolRequestsStillStreaming" }
  | { type: "ReadyForToolResponses" }
  | { type: "ContinuationRequested" }
  | { type: "Abort" }
  | { type: "Reset" }
  | { type: "ErrorOccurred" };

export function reduce(
  state: ConversationEngineState,
  evt: EngineEvent
): ConversationEngineState {
  switch (evt.type) {
    case "UserMessageSent":
      return { kind: "preparing_stream", isBusy: true };
    case "AssistantStreamStarted":
      return { kind: "streaming_text", isBusy: true };
    case "AssistantDisplayCompleted":
      if (evt.hasStreamingRequests) {
        return { kind: "streaming_tool_calls", isBusy: true };
      }
      return state; // no change here; follow-up events will decide
    case "AssistantTextCompleted":
      return { kind: "post_streaming", isBusy: true };
    case "ToolRequestsStillStreaming":
      return { kind: "streaming_tool_calls", isBusy: true };
    case "ReadyForToolResponses":
      return { kind: "awaiting_tool_responses", isBusy: true };
    case "ContinuationRequested":
      return { kind: "awaiting_ai_continuation", isBusy: true };
    case "Abort":
      return { kind: "aborted", isBusy: false };
    case "Reset":
      return { kind: "awaiting_user_input", isBusy: false };
    case "ErrorOccurred":
      return { kind: "error", isBusy: false };
    default:
      return state;
  }
}
